import { render, staticRenderFns } from "./GeometryField.vue?vue&type=template&id=2ea2bf12&scoped=true"
import script from "./GeometryField.vue?vue&type=script&lang=js"
export * from "./GeometryField.vue?vue&type=script&lang=js"
import style0 from "./GeometryField.vue?vue&type=style&index=0&id=2ea2bf12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea2bf12",
  null
  
)

export default component.exports